import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { urls } from '../constants';

import { useNavigate } from 'react-router-dom';

import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/dist/plugins/Captions';
import 'yet-another-react-lightbox/dist/styles.css';
import "yet-another-react-lightbox/dist/plugins/captions.css";

const Carte = () => {
    let navigate = useNavigate();

    // store photos in state
    const[photos, setPhotos] = useState([]);

    // lightbox open / close state
    const[isOpen, setIsOpen] = useState(true);

    // use effect hook to load presentation
    useEffect(() => {
        axios.get(urls.api_url+'circuit')
        .then((response) => {            
            if(response.status === 200) {
                const photosFromWP = response.data[0].photos;
                const photosForLightbox = [];

                photosFromWP.map((photo) => {
                    let photoForLightbox = {
                        src: photo.full_image_url,
                        title: photo.title,
                        description: 'description'
                    }
                    photosForLightbox.push(photoForLightbox)
                })

                setPhotos(photosForLightbox);
                setIsOpen(true);
            }
        });
    }, []);

    return (
        <Lightbox
            open={isOpen}
            close={() => {
                setIsOpen(false);
                navigate("/", {replace: true});
            }}
            slides={photos}
            plugins={[Captions]}
        />
    );
};

export default Carte;